import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'tt-dot',
  templateUrl: './dot.component.html',
  styleUrls: ['./dot.component.scss'],
  standalone: true,
  imports: [TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.background-color]': 'customColor()',
  },
})
export class DotComponent {
  public mode = input<'update' | 'notification' | 'alert'>('update');
  public customColor = input<string>('');
  public size = input<'small' | 'default' | 'large'>('default');

  @HostBinding('class')
  public get hostClasses(): string {
    return `tt-dot--${this.mode()} tt-dot--${this.size()}`;
  }
}
